import {useState} from "react";

import {ComboboxGeneric} from "@/components/ui/combobox-generic";
import {getStorageItem} from "@/src/modules/core/lib";

import {DailyActivityReportType} from "../types";

type DarTypeComboboxProps = {
  value: DailyActivityReportType | null;
  onChange: (value: DailyActivityReportType | null) => void;
};

export function DarTypeCombobox({value, onChange}: DarTypeComboboxProps) {
  const [dailyActivityReportTypes] = useState<DailyActivityReportType[]>(
    getStorageItem("dailyActivityReportTypes"),
  );

  const visibleTypes = (dailyActivityReportTypes ?? []).filter((t) => (t.visible ?? 1) === 1);

  return (
    <ComboboxGeneric<DailyActivityReportType>
      items={visibleTypes}
      value={value}
      onChange={onChange}
      getItemKey={(item) => `dar-type-${item.daily_activity_report_type_id}`}
      getItemLabel={(item) => item.type}
      isItemEqual={(item, selected) =>
        item.daily_activity_report_type_id === selected?.daily_activity_report_type_id
      }
      placeholder="Select type"
      emptyMessage="No items found."
    />
  );
}
